import { Typography } from '@twistopayments/design-system/components/atoms/typography'

import type { Category } from '@twisto/api-cms'

import { ArticlesSearchInput } from 'homepage/components'
import { useAdditionalData } from 'homepage/libs/context'

import * as styles from './main-category-header.styles'

export const MainCategoryHeader = ({ category }: { category: Category }) => {
  const { staticTexts } = useAdditionalData()

  return (
    <header css={styles.header}>
      <div css={styles.headerPatternBackground} />
      <div css={styles.headerContent}>
        <Typography
          align="center"
          color="textPrimary"
          component="h1"
          css={styles.headline}
          fontWeight="heavy"
          variant="h1"
        >
          {category.name}
        </Typography>
        <ArticlesSearchInput
          placeholder={staticTexts?.mainCategorySearchInputPlaceholder || ''}
        />
      </div>
    </header>
  )
}
